export default function () {
  $(".ajax-login-form").on("submit", function (e) {
    e.preventDefault();
    let msg = $(".ajax-login-error");
    msg.css("display", "none").empty();
    let user = $(".ajax-login-user").val();
    let pass = $(".ajax-login-pass").val();

    if (!user || !pass) {
      ajax_login_fail("Username / Email and Password are required");
    } else {
      ajax_login(user, pass);
    }
  });

  function ajax_login_fail(error) {
    let msg = $(".ajax-login-error");
    msg.css("display", "block").html(error);
  }

  // Ajax User
  function ajax_login(user, pass) {
    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "post",
      data: {
        action: "login_checkout",
        user: user,
        pass: pass,
      },
      success: function (response) {
        let res = JSON.parse(response);
        if (res.error) {
          ajax_login_fail(res.error);
        } else {
          location.reload();
        }
      },
      error: function () {},
    });
  }

  $(".ajax-register-form").on("submit", function (e) {
    e.preventDefault();
    let msg = $(".ajax-register-error");
    msg.css("display", "none").empty();
    let first_name = $(".ajax-register-first-name").val();
    let last_name = $(".ajax-register-last-name").val();
    let user = $(".ajax-register-user").val();
    let pass = $(".ajax-register-pass").val();

    if (!user || !pass || !first_name || !last_name) {
      ajax_register_fail("Username / Email and Password are required");
    } else {
      // console.log(user, pass, first_name, last_name); // eslint-disable-line
      ajax_register(user, pass, first_name, last_name);
    }
  });

  function ajax_register_fail(error) {
    let msg = $(".ajax-register-error");
    msg.css("display", "block").html(error);
  }

  /* eslint-disable */

  // Ajax User
  function ajax_register(user, pass, first_name, last_name) {
    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "post",
      data: {
        action: "register_checkout",
        user: user,
        pass: pass,
        first_name: first_name,
        last_name: last_name,
      },
      success: function (response) {
        let res = JSON.parse(response);
        if (!res.created) {
          ajax_register_fail(res.message);
        } else {
          location.reload();
          var url = window.location.href;
          if (url.indexOf("?") > -1) {
            url += "&recent-create-account=1";
          } else {
            url += "?recent-create-account=1";
          }
          window.location.href = url;
        }
      },
      error: function () {},
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/util/ajaxLogin.js